import { Grid } from '@material-ui/core';
import { useQuoteField } from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import { FormRowGrid, GridRowProps } from 'Quoting/components/shared/GridRow';
import { ConditionalSection, QuoteFormConditionalSection } from 'Quoting/components/shared/QuoteFormConditionalSection';
import { QuoteFormElement } from 'Quoting/components/shared/QuoteFormElement';
import { FormWrapper } from 'Quoting/components/shared/QuoteFormWrapper';
import React from 'react';
import { useSelector } from 'react-redux';
import { ReducerState } from 'rootReducer';
import {
  GPLUCoverageCode,
} from '../../../PlanTemplates/GWL/gpluConstants';
import { getAmountValuePath, getGPLUOptionsBlockPropertyPaths } from '../PropertyPaths';

const AccelDeathBenefit = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);
  const propertyPaths = getGPLUOptionsBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'row-9df56b5a-3bcd-43a2-a579-05811b4cbfa9'},
      items: [
        {
          key: '45b00e31-7da3-4d5b-9408-31dbbe80a302',
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Accelerated Benefit Maximum Percentage"
              id={propertyPaths.maxAcceleratedBenefitPct}
              value={getQuoteFieldValue(propertyPaths.maxAcceleratedBenefitPct)}
              type="number"
              adornment="percentage"
              required
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: '0046ecac-9e05-421d-a1f4-ca406934055b',
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Accelerated Benefit Maximum Amount"
              id={propertyPaths.maxAcceleratedBenefitAmount}
              value={getQuoteFieldValue(getAmountValuePath(propertyPaths.maxAcceleratedBenefitAmount))}
              type="number"
              adornment="money"
              required
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];
  return <FormRowGrid rows={rows} />;
};

export const GPLUSpouseOptionsBlock = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue, updateQuoteFieldValues} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);
  const propertyPaths = getGPLUOptionsBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);
     

  const rows1: GridRowProps[] = [
    {
      rowProps: {key: 'row-60ea6800-10df-4b66-b955-670f1b92d13d'},
      items: [
        {
          key: 'af6cef09-9c2a-4d36-a02d-2daaf355619e',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              label="Non-Forfeiture Default Option"
              id={propertyPaths.nonForfeitureDefaultOptionCd}
              value={getQuoteFieldValue(propertyPaths.nonForfeitureDefaultOptionCd)}
              onChange={e => updateQuoteFieldValue(propertyPaths.nonForfeitureDefaultOptionCd, e.target.value)}
              dropdownVariant="AttributeValue"
              searchKey="SpouseWLCoverage.nonForfeitureDefaultOptionCd"
              coverageCode={GPLUCoverageCode.SPOUSE_WHOLE_LIFE}
              required
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  const rows2: GridRowProps[] = [
    {
      rowProps: {key: 'row-6fff4203-5dff-4372-a616-848ce2071423'},
      items: [
        {
          key: '1dd4ddb5-b24b-4cce-9b6b-881abaf8267c',
          element: (
            <QuoteFormElement
              elementType="FormControl"
              label="PORTABILITY"
              id={propertyPaths.isPortabilityApplied}
              checked={getQuoteFieldValue<boolean>(propertyPaths.isPortabilityApplied)}
              onChange={e => updateQuoteFieldValue(propertyPaths.isPortabilityApplied, e.target.checked)}
              controlType="checkbox"
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  const additionalOptNBenefits: ConditionalSection[] = [
    {
      Component: AccelDeathBenefit,
      key: 'accelDeathBenefit',
      label: 'ACCEL DEATH BENEFIT FOR TERMINAL ILLNESS OR CONDITION RIDER',
      disabled: true,
      isApplied: getQuoteFieldValue(propertyPaths.isAccelerateBenefitRequired) || true,
    },
  ];

  return (
    <FormWrapper title="Options" collapsible withSeparator>
      <Grid container alignItems="center">
        <FormRowGrid rows={rows1} />
        <QuoteFormConditionalSection sections={additionalOptNBenefits} />
        <FormRowGrid rows={rows2} />
      </Grid>
    </FormWrapper>
  );
};
